import React from "react";
import { Button, Modal } from "react-bootstrap";
import "./modal.scss";

export const CancelOrderModal = ({
  handleClose,
  show,
  handleCancel,
  selectedId,
}) => {
  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Cancel Order</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Are you sure you want to cancel Order# {selectedId}?
      </Modal.Body>
      <Modal.Footer>
        <Button
          className="w-full !rounded-md bg-transparent h-[43px] !max-w-28 !border-b-color text-black !text-sm btn btn-secondary"
          variant="secondary"
          onClick={handleClose}
        >
          Cancel
        </Button>
        <Button
          className="w-full !rounded-md !bg-primary-blue h-[43px] !max-w-28 !border-primary-blue text-white !text-sm btn btn-secondary"
          onClick={handleCancel}
          variant="primary"
        >
          Submit
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
